export default "__VITE_ASSET__Hpr0YwFm__"